import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoggedInGuard } from "./guards/logged-in.guard";
import { AuthenticationService } from "./services/index";
import { UsersService } from "./services/users.service";
import { ConstantsService } from "./services/constants.service";
import { AlertModule } from "ngx-bootstrap";
import {
  ModalModule,
  DatepickerModule,
  TimepickerModule,
  PopoverModule
} from "ngx-bootstrap";
import { QuarterService } from "./services/quarter.service";
import { CustomFormsModule } from "ng2-validation";
import { AdvisorsService } from "./services/advisors.service";
import { PartnerService } from "./services/partner.service";
import { ManagerService } from "./services/manager.service";
import { SampleFileService } from "./services/sample-file.service";
import { EntryService } from "./services/entry.service";
import { AccountService } from "./services/account.service";
import { CoproducerService } from "./services/coproducer.service";
import { SignalRModule } from "ng2-signalr";
import { SignalRConfiguration } from "ng2-signalr";
import { environment } from "../environments/environment";
import { SignalrService } from "./services/signalr.service";
import { AuditLogService } from "./services/audit-log.service";
import { UserAccountService } from "./services/user-account.service";
import { SpinnyModule } from "./spinny/spinny.module";
import { NgxMyDatePickerModule } from "ngx-mydatepicker";
import { TypeaheadModule } from "ngx-bootstrap";
import { ReportsService } from "./services/reports.service";
import { RecaptchaModule } from "ng-recaptcha";
import { AuthInteceptor } from "./services/auth.interceptor";

const URL = environment.apiBaseUrl;

export function createConfig(): SignalRConfiguration {
  const c = new SignalRConfiguration();
  c.hubName = "Ng2SignalRHub";
  // c.qs = { user: 'donald' };
  c.url = URL;
  c.logging = true;
  return c;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    DatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    // LoginModule,
    // ShellModule,
    CustomFormsModule,
    SignalRModule.forRoot(createConfig),
    SpinnyModule,
    NgxMyDatePickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    RecaptchaModule.forRoot(),
    ModalModule.forRoot()
  ],
  providers: [
    AuthenticationService,
    LoggedInGuard,
    UsersService,
    ConstantsService,
    QuarterService,
    AdvisorsService,
    ConstantsService,
    PartnerService,
    ManagerService,
    SampleFileService,
    EntryService,
    AuditLogService,
    AccountService,
    CoproducerService,
    SignalrService,
    UserAccountService,
    ReportsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInteceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
